<template>
  <div>
    <v-container v-if="categoryAspect" fluid>
      <v-container fluid text-xs-center text-md-center text-sm-center pt-0>
        <v-layout v-if="act && act.faultSystem" row wrap justify-center>
          <v-btn
            @click="updateFault('warnings', 1)"
            :disabled="!edit"
            color="amber accent-3"
            >{{
              `${$t('warnings').toUpperCase()}: ${fault.warnings || 0}`
            }}</v-btn
          >
          <v-btn
            @click="updateFault('smallFaults', 1)"
            :disabled="!edit"
            color="orange accent-3"
            >{{
              `${$t('smallFaults').toUpperCase()}: ${fault.smallFaults || 0}`
            }}</v-btn
          >
          <v-btn
            @click="updateFault('smallFaults', -1)"
            :disabled="!edit"
            icon
            color="orange accent-3"
            >-</v-btn
          >
          <v-btn
            @click="updateFault('seriousFaults', 1)"
            :disabled="!edit"
            color="error"
            >{{
              `${$t('seriousFaults').toUpperCase()}: ${fault.seriousFaults ||
                0}`
            }}</v-btn
          >
          <v-btn
            @click="updateFault('seriousFaults', -1)"
            :disabled="!edit"
            icon
            color="error"
            >-</v-btn
          >
        </v-layout>
      </v-container>
      <v-container fluid text-xs-center py-0>
        <v-layout row wrap>
          <v-flex d-flex xs12 align-self-center>
            <v-flex xs12 md9 class="text-uppercase">{{
              $tc('aspect', 2)
            }}</v-flex>
            <v-flex xs12 sm3 md3 class="text-uppercase">{{
              localCategoryAspect.objectTitle || $t('name')
            }}</v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <hr />
      <template v-for="(typeAspect, index) in categoryAspect.typeAspects">
        <v-container fluid grid-list-md :key="index + 1500">
          <v-layout row wrap>
            <v-flex d-flex xs12 sm2 md2 align-self-center>{{
              typeAspect ? typeAspect.name : ''
            }}</v-flex>
            <v-flex xs12 sm10 md10>
              <v-layout
                row
                wrap
                v-for="(aspect, index) in getAspects(typeAspect.aspects)"
                :key="index + 2500"
              >
                <v-flex d-flex xs12 sm6 md6 align-self-center>{{
                  aspect ? aspect.name : ''
                }}</v-flex>

                <v-flex d-flex xs12 sm6 md6 align-self-center>
                  <div v-if="aspect.typeScore === 'checkbox'">
                    <v-checkbox
                      color="primary"
                      v-model="aspect.score"
                      @change="score => updateAspectScore(aspect, score)"
                      :disabled="!edit"
                    ></v-checkbox>
                  </div>
                  <div v-else-if="aspect.typeScore === 'textbox'">
                    <v-text-field
                      v-model="aspect.score"
                      @change="score => updateAspectScore(aspect, score)"
                      type="number"
                      :disabled="!edit"
                    ></v-text-field>
                  </div>
                  <div v-else-if="aspect.typeScore === 'select'">
                    <v-select
                      v-model="aspect.score"
                      @change="score => updateAspectScore(aspect, score)"
                      :items="
                        Array.from(
                          { length: aspect.untilSelect + 1 },
                          (v, i) => i
                        )
                      "
                      :disabled="!edit"
                    ></v-select>
                  </div>
                  <div v-else-if="aspect.typeScore === 'options'">
                    <v-radio-group
                      :value="aspect.score + ''"
                      @change="score => updateAspectScore(aspect, score)"
                      :disabled="!edit"
                      row
                    >
                      <template v-for="option in aspect.options">
                        <v-radio
                          :label="option.value + ' - ' + option.name"
                          color="primary"
                          :value="option.value"
                          :key="option._id"
                        ></v-radio>
                      </template>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <hr :key="3500 + index" />
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { debounce } from 'debounce'
export default {
  name: 'tabIndividual',
  props: {
    categoryAspect: { type: Object, default: () => {} },
    score: { type: Object, default: () => {} },
    matchType: {
      type: String,
      required: true,
      default: ''
    },
    judgeId: { type: String, default: '' },
    edit: { type: Boolean, default: false }
  },
  data() {
    return {
      localCategoryAspect: {},
      aspectsScored: [],
      faults: [],
      scoreTemplate: {
        aspectRelId: '',
        type: '',
        objectId: '',
        score: 0,
        judgeId: ''
      },
      // fault: {},
      faultTemplate: {
        type: '',
        objectId: '',
        seriousFaults: 0,
        smallFaults: 0,
        warnings: 0,
        judgeId: ''
      }
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  watch: {
    actId: function(val) {
      if (Object.keys(this.categoryAspect).length) {
        this.init()
      }
    },
    categoryAspect(val) {
      if (Object.keys(val).length) {
        this.init()
      }
    }
  },
  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      actId: state => state.acts.idSelected,
      scoreId: state => state.matches.scoreId,
      match: state => state.matches.matchSelected,
      authUser: state => state.authentication.user,
      pendingAspects: state => state.matches.pendingAspects,
      pendingFaults: state => state.matches.pendingFaults,
      getFaults: state => state.acts.faults
    }),

    currentAspects() {
      return this.pendingAspects[this.scoreId] || []
    },
    currentFaults() {
      return this.pendingFaults[this.scoreId] || []
    },
    typeAspects() {
      return []
    },
    fault() {
      return (
        this.getFaults.find(
          fault =>
            fault.objectId === this.categoryAspect.objectId &&
            fault.judgeId === this.judgeId
        ) || {
          ...this.faultTemplate,
          type: this.matchType,
          objectId: this.categoryAspect.objectId,
          judgeId: this.judgeId
        }
      )
    }
  },
  methods: {
    ...mapActions({
      setFaultScore: 'acts/setFaultScore',
      setAspectScore: 'acts/setAspectScore',
      setPendingFaults: 'matches/setPendingFaults'
    }),
    ...mapMutations({
      setPendingAspects: 'matches/setPendingAspects'
    }),
    getAspects(aspects) {
      const getAspect = (scores, aspectRelId) =>
        scores.find(
          aspectScored =>
            aspectScored.aspectRelId == aspectRelId &&
            aspectScored.judgeId == this.judgeId &&
            aspectScored.objectId === this.categoryAspect.objectId
        )
      return aspects.map(aspect => {
        let aspectScored =
          getAspect(this.currentAspects, aspect._id) ||
          getAspect(this.score.aspects, aspect._id)
        const score = aspectScored ? aspectScored.score : 0

        return {
          ...aspect,
          score: aspect.typeScore === 'checkbox' ? !!score : score
        }
      })
    },
    init() {
      let vm = this
      setTimeout(() => {
        if (!vm.categoryAspect || !Object.keys(vm.categoryAspect).length) return
        vm.localCategoryAspect = { ...vm.categoryAspect }

        // aspectScored
        let score = vm.act.scores.find(score => score._id === vm.match.actId)
        if (score) {
          vm.initScores(score)
        }
      }, 500)
    },
    initScores(score) {
      this.aspectsScored = []
      this.act.aspects.forEach(aspect => {
        if (aspect.categoryAspect != this.localCategoryAspect._id) return
        let aspectScored = score.aspects.find(
          aspectScored =>
            aspectScored.aspectRelId == aspect._id &&
            aspectScored.judgeId == this.judgeId &&
            aspectScored.objectId === this.localCategoryAspect.objectId
        )
        if (aspectScored) {
          this.aspectsScored.push(aspectScored)
          this.setCategoryAspect(aspect._id, aspectScored)
        } else {
          this.aspectsScored.push({
            aspectRelId: aspect._id,
            type: this.matchType,
            objectId: this.localCategoryAspect.objectId,
            judgeId: this.judgeId,
            score: 0
          })
        }
      })
    },

    setCategoryAspect(aspectRelId, aspectScored) {
      if (!this.localCategoryAspect.typeAspects) return
      this.localCategoryAspect.typeAspects.forEach(typeAspect => {
        typeAspect.aspects.forEach(aspect => {
          if (!aspect) return
          if (
            aspect.aspectRelId == aspectRelId &&
            aspectScored.objectId == this.localCategoryAspect.objectId
          ) {
            aspect.score =
              aspect.typeScore == 'checkbox'
                ? !!aspectScored.score
                : aspectScored.score
          }
        })
      })
    },
    updateAspectScore(aspect, score) {
      const payload = {
        judgeId: this.judgeId,
        objectId: this.categoryAspect.objectId,
        aspectRelId: aspect._id,
        score: Number(score)
      }
      this.setPendingAspects(payload)
    },
    setAspectScoreDebounce: debounce(function(scoreId, aspectScore) {
      this.setAspectScore({
        scoreId,
        aspectScore
      })
    }, 1000),
    updateFault(type, number) {
      switch (type) {
        case 'seriousFaults':
          this.fault.seriousFaults += number
          if (this.fault.seriousFaults < 0) {
            this.fault.seriousFaults = 0
            return
          }
          break
        case 'smallFaults':
          this.fault.smallFaults += number
          if (this.fault.smallFaults < 0) {
            this.fault.smallFaults = 0
            return
          }
          break
        case 'warnings':
          this.fault.warnings += number
          if (this.fault.warnings >= 2) {
            this.fault.smallFaults++
            this.fault.warnings = 0
          }
          break
        default:
          break
      }
      this.setPendingFaults(this.fault)
      // this.setFaultScoreDebounce(this.match.actId, this.fault)
    },
    setFaultScoreDebounce: debounce(function(scoreId, aspectScore) {
      this.setFaultScore({
        scoreId,
        faultScore: this.fault
      })
    }, 1000)
  }
}
</script>

<style scoped></style>
